import request from '@/utils/request'

// 获取轮播图
export function getBanner() {
  return request({
    url: '/getBanner',
    method: 'get'
  })
}

// 获取网站设置
export function getSiteConfig() {
  return request({
    url: '/siteConfig',
    method: 'get'
  })
}

// 获取园林景观
export function getGardens() {
  return request({
    url: '/getGardens',
    method: 'get'
  })
}

// 获取人文纪念列表
export function getRemembers() {
  return request({
    url: '/getRemembers',
    method: 'get'
  })
}

// 预约咨询
export function reserve(data) {
  // 将数据转换为 URLSearchParams 格式（application/x-www-form-urlencoded）
  const params = new URLSearchParams();
  params.append('title', data.title || '');
  params.append('name', data.name || '');
  params.append('phone', data.phone || '');
  if (data.remark) {
    params.append('remark', data.remark);
  }
  
  return request({
    url: '/reserve',
    method: 'post',
    data: params
  })
}

// 获取购墓列表（区域列表）
export function getCemeteryAreaList() {
  return request({
    url: '/cemetery/area/list',
    method: 'get'
  })
}

// 获取产品列表
export function getProducts() {
  return request({
    url: '/getProducts',
    method: 'get'
  })
}

// 获取产品详情
export function getProduct(productId) {
  return request({
    url: '/getProduct',
    method: 'get',
    params: {
      product_id: productId
    }
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/getUserInfo',
    method: 'get'
  })
}

// 添加逝者
export function addAway(data) {
  // 将数据转换为 URLSearchParams 格式（application/x-www-form-urlencoded）
  const params = new URLSearchParams();
  params.append('name', data.name || '');
  
  return request({
    url: '/addAway',
    method: 'post',
    data: params
  })
}

// 获取逝者列表
export function getAwayList() {
  return request({
    url: '/awayList',
    method: 'get'
  })
}

// 人文纪念下单
export function createRememberOrder(data) {
  // 将数据转换为 URLSearchParams 格式（application/x-www-form-urlencoded）
  const params = new URLSearchParams();
  params.append('remember_id', data.remember_id || '');
  params.append('away_id', data.away_id || '');
  
  return request({
    url: '/createRememberOrder',
    method: 'post',
    data: params
  })
}

// 购墓下单
export function createOrder(data) {
  // 将数据转换为 URLSearchParams 格式（application/x-www-form-urlencoded）
  const params = new URLSearchParams();
  params.append('product_id', data.product_id || '');
  params.append('away_id', data.away_id || '');
  
  return request({
    url: '/createOrder',
    method: 'post',
    data: params
  })
}

// 下单后发起支付，返回支付URL
export function goPay(data) {
  const params = new URLSearchParams()
  params.append('order_no', data.order_no || '')

  return request({
    url: '/goPay',
    method: 'get',
    params: {
      order_no: data.order_no || ''
    }
  })
}

// 查询订单详情（用于轮询支付状态）
export function getOrderDetail(orderNo) {
  return request({
    url: '/getOrderDetail',
    method: 'get',
    params: {
      order_no: orderNo
    }
  })
}

// 我的订单列表
export function myOrder(query = {}) {
  return request({
    url: '/myOrder',
    method: 'get',
    params: query
  })
}

// 获取墓葬展示列表（新接口）
export function getShapeList() {
  return request({
    url: 'https://koh30.shangyundian.cn/api/getShapeList',
    method: 'get'
  })
}

// 获取墓葬展示列表（旧接口，保留兼容）
export function getShapes(cateId) {
  return request({
    url: '/getShapes',
    method: 'get',
    params: cateId ? { cate_id: cateId } : {}
  })
}

// 获取服务项目列表
export function getProjects() {
  return request({
    url: '/getProjects',
    method: 'get'
  })
}

